var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    {
      attrs: {
        id: "web-store-credentials-and-keys",
        title: "Web Store Credentials and Keys",
      },
    },
    [
      _vm._v("\n  The\n  "),
      _c("em", [_vm._v("Customer")]),
      _vm._v("\n  agrees to keep license keys for\n  "),
      _c("em", [_vm._v("Font Awesome Pro")]),
      _vm._v("\n  confidential, and to ensure that the\n  "),
      _c("em", [_vm._v("Customer")]),
      _vm._v("'s employees, contractors, "),
      _c("em", [_vm._v("Creators")]),
      _vm._v(", and other personnel keep them confidential, as well. The\n  "),
      _c("em", [_vm._v("Customer")]),
      _vm._v("\n  agrees to keep the\n  "),
      _c("em", [_vm._v("Customer")]),
      _vm._v("'s\n  "),
      _c("em", [_vm._v("Web Store")]),
      _vm._v(
        "\n  access credentials confidential, and to ensure that only the\n  "
      ),
      _c("em", [_vm._v("Customer")]),
      _vm._v("\n  accesses the\n  "),
      _c("em", [_vm._v("Web Store")]),
      _vm._v("\n  with the\n  "),
      _c("em", [_vm._v("Customer")]),
      _vm._v("'s credentials.\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }